const {
    FILE_CATEGORY,
    FILE_STATUS,
    FILE_ACCESS,
    REQUIRED_PERSON_FILE_CATEGORY,
    REQUIRED_COMPANY_FILE_CATEGORY
} = require('./FileConstant');
const {genHash, fsMomentImport} = require('../utils/utils');
const moment = require("moment");

class File {

    constructor({
                    id = genHash(16),
                    type = 'application/octet-stream',
                    name = '',
                    path = '',
                    url = '',
                    data,
                    fileSize = 0,
                    status = FILE_STATUS.UNCHECKED,
                    category = FILE_CATEGORY.OTHER,
                    access = FILE_ACCESS.PROTECTED,

                    created = moment(),
                    createdBy = '',
                    updated = moment(),
                    updatedBy = '',
                } = {}) {

        this.id = id;
        this.type = type;
        this.name = name;
        this.path = path;
        this.url = url;
        this.data = data;
        this.fileSize = Number.isNaN(fileSize) ? 0 : fileSize;
        this.status = FILE_STATUS[status] ? status : FILE_STATUS.UNCHECKED;
        this.category = FILE_CATEGORY[category] ? category : FILE_CATEGORY.OTHER;
        this.access = FILE_ACCESS[access] ? access : FILE_ACCESS.PROTECTED;

        this.created = null;
        this.updated = null;
        const field = ['created', 'updated'];
        [created, updated].forEach((date, index) => {
            date = fsMomentImport(date)
            this[field[index]] = date && date.isValid() ? date : null
        })
        this.createdBy = createdBy;
        this.updatedBy = updatedBy;
    }

    static get FILE_CATEGORY() {
        return FILE_CATEGORY;
    }

    static get FILE_STATUS() {
        return FILE_STATUS;
    }

    static get FILE_ACCESS() {
        return FILE_ACCESS;
    }

    static get REQUIRED_PERSON_FILE_CATEGORY() {
        return REQUIRED_PERSON_FILE_CATEGORY;
    }

    static get REQUIRED_COMPANY_FILE_CATEGORY() {
        return REQUIRED_COMPANY_FILE_CATEGORY;
    }

    static fileExtensionFromType(type) {
        const extension = type.indexOf('/') !== -1 ?
            type.substring(type.indexOf('/') + 1) :
            '';
        // shorten jpeg to jpg
        return extension === 'jpeg' ? 'jpg' : extension;
    }

    get fileExtension() {
        return File.fileExtensionFromType(this.type);
    }

    static fromFile(file, pathPrefix = '') {
        const extension =  File.fileExtensionFromType(file.type);
        const name = file.name.length < 40 ?
            file.name : file.name.substring(0, 35) + '.' + extension;
        const id = genHash(16);
        return new File({
            id,
            type: file.type,
            path: `${pathPrefix}/${id}.${extension}`,
            name: name,
            data: file,
            fileSize: file.size
        })
    }

    toFirestore() {
        return {
            'id': this.id,
            'type': this.type,
            'name': this.name,
            'path': this.path,
            'fileSize': this.fileSize,
            'status': this.status,
            'category': this.category,
            'access': this.access,
            'created': this.created && (typeof this.created.toDate === 'function') ? this.created.toDate() : null,
            'createdBy': this.createdBy,
            'updated': this.updated && (typeof this.updated.toDate === 'function') ? this.updated.toDate() : null,
            'updatedBy': this.updatedBy,
        }
    }

    static parseFirestore(file) {
        return new File(file);
    }

    static fromFirestore(fsSnap) {
        const data = {};
        if (fsSnap) {
            Object.keys(fsSnap).forEach((key) => {
                // the firestore object is not null
                if (fsSnap[key]) {
                    data[key] = File.parseFirestore(fsSnap[key])
                }
            });
        }
        return data
    }
}

module.exports = File;